import axios from 'axios';

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
});

api.interceptors.request.use((config) => {
  const pin = localStorage.getItem('delogo_access_pin');
  if (pin) {
    config.headers['x-access-pin'] = pin;
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response && err.response.status === 401) {
      localStorage.removeItem('delogo_access_pin');
      window.location.reload();
    }
    return Promise.reject(err);
  }
);

export { api };
